/**
 * Entry application component used to compose providers and render Routes.
 * */

import React from 'react';
import { Routes } from './Routes';
import { Provider } from 'react-redux';
import { I18nProvider } from './_metronic/i18n';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import PathnameWrapper from './common/components/PathnameWrapper';
import { LayoutSplashScreen, MaterialThemeProvider } from './_metronic/layout';

export default function App({ store, persistor, basename }) {
	const arrayurl = window.location.href.split('saoc-module-web');
	localStorage.setItem('prevUrl', arrayurl[arrayurl.length - 1]);
	localStorage.setItem('login', false);

	return (
		/* Provide Redux store */
		<Provider store={store}>
			{/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
			<PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
				{/* Add high level `Suspense` in case if was not handled inside the React tree. */}
				<React.Suspense fallback={<LayoutSplashScreen />}>
					{/* Override `basename` (e.g: `homepage` in `package.json`) */}
					<BrowserRouter basename={basename}>
						{/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
						<MaterialThemeProvider>
							{/* Provide `react-intl` context synchronized with Redux state.  */}
							<I18nProvider>
								{/* Render routes with provided `Layout`. */}
								<PathnameWrapper>
									<Routes />
								</PathnameWrapper>
							</I18nProvider>
						</MaterialThemeProvider>
					</BrowserRouter>
				</React.Suspense>
			</PersistGate>
		</Provider>
	);
}
